// extracted by mini-css-extract-plugin
export var activeFilterButton = "_si-c";
export var backButton = "_si-4";
export var backIcon = "_si-5";
export var chevronShortcut = "_si-6";
export var container = "_si-1";
export var editor = "_si-8";
export var editorWrapper = "_si-7";
export var prefix = "_si-2";
export var searchIcon = "_si-3";
export var suffix = "_si-9";
export var suffixContent = "_si-a";
export var suffixText = "_si-b";
export var wrapper = "_si-0";